/* eslint-disable import/no-unused-modules */
import Divider from '@mui/material/Divider';
import Typography from '@mui/material/Typography';
import React from 'react';
import Link from '@mui/material/Link';
import HeaderCard from '../General/HeaderCard';
import OrderBySelect from '../Post/OrderBySelect';
import LegalNotice from '../Sidebar/LegalNotice';

export default function CommunityAbout({
  community,
  handleChangeSort,
  sortTitle,
}) {
  const {
    about,
    flag_text,
    description,
    team,
    subscribers,
    num_authors,
  } = community;

  return (
    <>
      {handleChangeSort && (
        <div className="pt-3">
          <OrderBySelect handleClick={handleChangeSort} selection={sortTitle} />
        </div>
      )}
      <div className="pt-3">
        <HeaderCard
          nobottomborder
          title="About"
          titlesize="h5"
          bgCard
          content={
            <>
              <Typography variant="body1">
                {description.replace(
                  'This community is part of TravelFeed.',
                  '',
                ) || about}
              </Typography>
              <Divider className="mt-3 mb-3" />
              <div className="container pb-2">
                <div className="row">
                  <div className="col-6 text-center">
                    <Typography variant="h4">{subscribers}</Typography>{' '}
                    <Typography variant="subtitle2">followers</Typography>
                  </div>
                  <div className="col-6 text-center">
                    <Typography variant="h4">{num_authors}</Typography>{' '}
                    <Typography variant="subtitle2">active</Typography>
                  </div>
                </div>
              </div>
            </>
          }
        />
      </div>
      <div className="pt-3">
        <HeaderCard
          bgCard
          nobottomborder
          title="Team"
          titlesize="h5"
          content={
            <>
              <Typography variant="body1">
                <ul className="list-unstyled">
                  {team.map(member => {
                    if (member[1] !== 'owner')
                      return (
                        <li>
                          <Link color="textPrimary" href={`/@${member[0]}`}>
                            <Typography color="primary" display="inline">
                              @{member[0]}
                            </Typography>
                          </Link>{' '}
                          <span className="badge badge-info">{member[2]}</span>
                          <span className="badge badge-info">{member[1]}</span>
                        </li>
                      );
                    return <></>;
                  })}
                </ul>
              </Typography>
            </>
          }
        />
      </div>
      {flag_text && (
        <div className="pt-3">
          <HeaderCard
            nobottomborder
            title="Rules"
            titlesize="h5"
            bgCard
            content={
              <>
                <Typography variant="body1">
                  <ol>
                    {flag_text.split(/\n/).map(rule => {
                      if (
                        rule ===
                        'More info: https://travelfeed.com/blog/updated-how-to-participate-on-travelfeed-io'
                      )
                        return (
                          <li>
                            <Link
                              color="textPrimary"
                              href="/blog/updated-how-to-participate-on-travelfeed-io"
                            >
                              <Typography color="primary" display="inline">
                                More info
                              </Typography>
                            </Link>
                          </li>
                        );
                      return <li key={rule}>{rule}</li>;
                    })}
                  </ol>
                </Typography>
              </>
            }
          />
        </div>
      )}
      <LegalNotice />
    </>
  );
}
